import {useApiQuery, LogUtils} from '@wallaby-ui/core';
import {useEffect} from 'react';

import {AGENS_REDUCER_STATE_ID} from '../agens_constants';
import {agensSlice} from '../agens_slice';
import {constants} from 'src/js/common';
import {HaidiSchema} from 'src/js/common/types';
import {useAppDispatch, useAppSelector} from 'src/js/store_hooks';

const logger = LogUtils.getLogger('useLoadAgens', constants.LIBRARY_NAME);

export interface UseLoadAgensReturnValue {
  isLoading: boolean;
  error: unknown;
}

export function useLoadAgens(apiUrl: string): UseLoadAgensReturnValue {
  const isInitialized = useAppSelector(
    (state) => state[AGENS_REDUCER_STATE_ID].isInitialized
  );

  const {data, isLoading, error} = useApiQuery<
    HaidiSchema.components['schemas']['HaiPathogenDto'][]
  >([apiUrl], null, {
    axiosConfig: {url: apiUrl},
    reactQueryOptions: {
      enabled: !isInitialized,
    },
  });

  const dispatch = useAppDispatch();

  useEffect(() => {
    if (data && !isInitialized) {
      dispatch(agensSlice.actions.addFilterData({filterData: data}));
    }
  }, [data, dispatch, isInitialized]);

  useEffect(() => {
    if (error) {
      logger.warn(`Error when loading agens!\n ${error}`);
    }
  }, [error]);

  return {isLoading, error};
}
